import React from "react";

const Img = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M11 10C12.1046 10 13 10.8954 13 12V13.5C13 15.5544 10.912 17 7.5 17C4.08805 17 2 15.5544 2 13.5V12C2 10.8954 2.89543 10 4 10H11ZM11 11H4C3.44772 11 3 11.4477 3 12V13.5C3 14.9071 4.57862 16 7.5 16C10.4214 16 12 14.9071 12 13.5V12C12 11.4477 11.5523 11 11 11ZM16 10C17.1046 10 18 10.8954 18 12V12.5C18 14.5886 16.4317 16 13.5 16C13.3587 16 13.2206 15.9967 13.0856 15.9902C13.2938 15.7482 13.4684 15.4875 13.6076 15.209L13.705 14.996L13.7438 14.9965C15.976 14.9312 17 13.9593 17 12.5V12C17 11.4477 16.5523 11 16 11L13.829 10.9991C13.6971 10.6265 13.4937 10.2876 13.2353 9.99912L16 10ZM7.5 2C9.433 2 11 3.567 11 5.5C11 7.433 9.433 9 7.5 9C5.567 9 4 7.433 4 5.5C4 3.567 5.567 2 7.5 2ZM14.5 4C15.8807 4 17 5.11929 17 6.5C17 7.88071 15.8807 9 14.5 9C13.1193 9 12 7.88071 12 6.5C12 5.11929 13.1193 4 14.5 4ZM7.5 3C6.11929 3 5 4.11929 5 5.5C5 6.88071 6.11929 8 7.5 8C8.88071 8 10 6.88071 10 5.5C10 4.11929 8.88071 3 7.5 3ZM14.5 5C13.6716 5 13 5.67157 13 6.5C13 7.32843 13.6716 8 14.5 8C15.3284 8 16 7.32843 16 6.5C16 5.67157 15.3284 5 14.5 5Z"
        fill="#fff"
      />
      <path
        d="M11 30C12.1046 30 13 30.8954 13 32V33.5C13 35.5544 10.912 37 7.5 37C4.08805 37 2 35.5544 2 33.5V32C2 30.8954 2.89543 30 4 30H11ZM16 30C17.1046 30 18 30.8954 18 32V32.5C18 34.5886 16.4317 36 13.5 36C13.3587 36 13.2206 35.9967 13.0856 35.9902C13.625 35.3625 13.9439 34.6041 13.9932 33.7387L14 33.5V32C14 31.3081 13.7658 30.6709 13.3723 30.1634L13.2353 29.9991L16 30ZM7.5 22C9.433 22 11 23.567 11 25.5C11 27.433 9.433 29 7.5 29C5.567 29 4 27.433 4 25.5C4 23.567 5.567 22 7.5 22ZM14.5 24C15.8807 24 17 25.1193 17 26.5C17 27.8807 15.8807 29 14.5 29C13.1193 29 12 27.8807 12 26.5C12 25.1193 13.1193 24 14.5 24Z"
        fill="black"
      />
    </svg>
  );
};

export default Img;
